import React, { useContext, useEffect, useState } from "react";
import CreateButton from "../../../CommonElements/Button/CreateButton";
import FormTambahCuti from "./FormTambahCuti";
import { EditButton, FormModal } from "../../../CommonElements";
import { PERMISSIONS } from "../../../Constant/FeatureSelection";
import RoleContext from "../../../Context/RoleContext";
import { useAbsensi } from "../../../Context/AbsensiContext";
import { useStaf } from "../../../Context/StafContext";

const CutiModal = ({ create, data, resetState }) => {
  const absensiAPI = useAbsensi();
  const stafAPI = useStaf();
  const { checkPermission } = useContext(RoleContext);

  const [isOpen, setIsOpen] = useState(false);
  const toggle = () => setIsOpen(!isOpen);

  const [title] = useState(create ? "Buat Cuti Baru" : "Lihat Cuti");

  const [button] = useState(
    create ? (
      checkPermission(PERMISSIONS.ADD_CUTI) && <CreateButton toggle={toggle}>Buat Cuti Baru</CreateButton>
    ) : (
      checkPermission(PERMISSIONS.CHANGE_CUTI) && <EditButton toggle={toggle}>Lihat</EditButton>
    )
  );

  const [staf, setStaf] = useState([]);
  const [tipeAbsensi, setTipeAbsensi] = useState([]);

  let isMounted = true;
  useEffect(() => {
    const fetchData = async () => {
      absensiAPI.getTipeAbsensi().then((res) => {
        setTipeAbsensi(res.data);
      });
      stafAPI.getStaf().then((res) => {
        setStaf(res.data);
      });
    };

    if (isMounted) fetchData();
    return () => {
      isMounted = false;
    };
  }, []);

  return (
    <>
      {button}
      <FormModal
        title={title}
        isOpen={isOpen}
        toggle={toggle}
        size={!create && "lg"}
      >
        <FormTambahCuti
          resetState={resetState}
          toggle={toggle}
          data={data}
          tipeAbsensi={tipeAbsensi}
          staf={staf}
          create={create}
        />
      </FormModal>
    </>
  );
};

export default CutiModal;
